import { createContext } from "react";

export const WeatherContext = createContext(null);
